const INITIAL_STATE = {
  loading: false,
  loading_message: null,
  plus_error: null,
  data_loaded: false,
  project_id: null,
  td_version_id: null,
  shops: [],
  categoriesByShopId: {},
  activeShopId: null,
  activeCategoryId: null,
  activeTask: null,
  app_session_id: null,
  upload_view: null,
  uploading_images: false,
  uploading_counter: 0,
  upload_type: null,
  upload_title: null,
  upload_images_list: [],
  total_images_to_upload: 0,
  pending_upload_images: 0,
  images_uploaded_count: 0,
  all_images_uploaded: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case "PLUS_LOADING":
      return {
        ...state,
        loading: payload.loading,
        loading_message: payload.loading ? payload.message || null : null,
        plus_error: null,
      };

    case "PLUS_SET_DATA":
      return {
        ...state,
        shops: payload.shops,
        categoriesByShopId: payload.categoriesByShopId,
        project_id: payload.project_id,
        td_version_id: payload.td_version_id,
        data_loaded: true,
        loading: false,
        loading_message: null,
        plus_error: null,
      };

    case "PLUS_ERROR":
      return {
        ...state,
        loading: false,
        loading_message: null,
        plus_error: payload,
      };

    case "PLUS_SET_ACTIVE_SHOP":
      return {
        ...state,
        activeShopId: parseInt(payload),
        activeCategoryId: null,
        activeTask: null,
        app_session_id: null,
        upload_view: null,
      };

    case "PLUS_SET_ACTIVE_CATEGORY":
      return {
        ...state,
        activeCategoryId: parseInt(payload),
        activeTask: null,
        app_session_id: null,
        upload_view: null,
      };

    case "PLUS_SET_ACTIVE_TASK":
      return {
        ...state,
        activeTask: payload.task,
        app_session_id: payload.app_session_id,
        upload_view: null,
      };

    case "PLUS_TOGGLE_UPLOAD_VIEW":
      return { ...state, upload_view: payload };

    case "PLUS_SET_UPLOADING_IMAGES":
      return {
        ...state,
        upload_type: payload.type,
        upload_title: payload.title,
        upload_images_list: payload.fileList,
        total_images_to_upload: payload.fileList.length,
        pending_upload_images: payload.fileList.length,
        images_uploaded_count: 0,
        all_images_uploaded: false,
      };

    case "PLUS_RESET_UPLOADING_IMAGES":
      return {
        ...state,
        uploading_images: false,
        upload_type: null,
        upload_title: null,
        upload_images_list: [],
        total_images_to_upload: 0,
        pending_upload_images: 0,
        images_uploaded_count: 0,
        all_images_uploaded: false,
      };

    case "PLUS_UPLOADING_IMAGES_START":
      if (state.pending_upload_images !== 0) {
        return {
          ...state,
          uploading_images: true,
          uploading_counter: 0,
          pending_upload_images:
            state.total_images_to_upload - state.images_uploaded_count,
        };
      }
      return { ...state, uploading_images: true, all_images_uploaded: false };

    case "PLUS_UPDATE_PROCESSED_COUNTER": {
      const uploading_counter = state.uploading_counter + 1;
      if (uploading_counter === state.pending_upload_images) {
        return { ...state, uploading_counter: 0, uploading_images: false };
      }
      return { ...state, uploading_counter };
    }

    case "PLUS_SUCCESS_IMAGE_UPLOAD": {
      const images_uploaded_count = state.images_uploaded_count + 1;
      return {
        ...state,
        images_uploaded_count,
        all_images_uploaded:
          images_uploaded_count === state.total_images_to_upload,
      };
    }

    case "PLUS_REMOVE_UPLOADED_IMG":
      return {
        ...state,
        upload_images_list: state.upload_images_list.filter(
          (f) => f.image_id !== payload,
        ),
      };

    case "LOGOUT":
      return { ...INITIAL_STATE };

    default:
      return state;
  }
};
